import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function EditGroupMode(state = initialState.isGroupEditMode, action) {
	switch (action.type) {
		case types.SET_EDIT_ACCESSGROUP: {
			return action.value;
		}
		default:
			return state;
	}
}
